<template>
    <ButtonGroup class="mb-2@large"><!-- mb-2@large: slightly larger gap after this group -->
      <a @click.prevent="goToPersonalisazion" target="_blank" class="btn w-100">
        {{ 'ttxtDesignOnline'|translate }}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8 12.8" class="svg-icon ml-2 fill-white">
          <path d="M8.7 6.4c0 .2-.1.3-.2.5L5 10.7l-1-.9 3-3.4L4.1 3l1-.9 3.5 3.8c.1.2.1.3.1.5z" fill="#3a3a39"/>
        </svg>
      </a>
    </ButtonGroup>
</template>

<script>
import ButtonGroup from "./sidebarbuttons/ButtonGroup";
import {translatePrj} from "classes/vue-dict-filter";
import {CreatexApi} from "../classes/createx-api";

export default {
  name: 'CreateXButtonGroup',
  components: {ButtonGroup},
  inject: ['globalConfig', 'configuratorService'],
  methods: {
    goToPersonalisazion() {

      if (this.globalConfig.externalTrackingEnabled) {
        window.dataLayer.push({
          'event': 'button-click',
          'type': 'Button',
          'text': translatePrj("ttxtDesignOnline"),
          'product': this.globalConfig.product_name
        });
      }
      const restore_param = this.configuratorService.saveConfiguration("createX product config", true)
      restore_param.then(x => {
        let createXOption = this.configuratorService.byConfigoptionType("CreateX");
            new CreatexApi().getPersonalization(
                createXOption.customValues.webproduct,
                createXOption.customValues.template_id,
                x.id,
                this.globalConfig.printQCustomer,
                this.globalConfig.locale,
                this.configuratorService.byConfigoptionType("CreateX").dynamicValues.CreateXCustomDesignId
            ).then(response => {
              window.open(response.url, '_self');
            }).catch(xhr => {
              console.log(xhr)
            })
          }
      )

    },
  },
  created: function(){
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    let jwt = params.get("jwt");
    if( jwt){
      this.configuratorService.byConfigoptionType("CreateX").dynamicValues.createXjwt = params.get("jwt");
    }
  }
}
</script>